import React, { Component } from "react";
import _ from "lodash";

import Button from "../elements/Button";

class CinemaResults extends Component {

  render() {
    if (!this.props.results.cinemas) {
      return <div />;
    }
    const { cinemas, location } = this.props.results;
    return (
      <div className="page cinema-results">
        <h2>
          {cinemas.length > 0 ? "Cinemas near " + location : ""}
        </h2>
        <h3>Select a Cinema</h3>
        {_.map(cinemas, (cinema, id) => {
          return (
            <div className="cinema-result">
              {cinema.name}
              <Button
                blue
                onClicked={() => this.props.searchWithCinema(cinema)}
              >
                select
              </Button>
            </div>
          );
        })}
      </div>
    );
  }
}

export default CinemaResults;



// WEBPACK FOOTER //
// ./src/components/CinemaResults.js